import { httpClient } from '../http/httpClient'
import {
  SupportRequest,
  SupportRequestReason,
} from '@/app/entities/SupportRequest'

export interface CreatePublicSupportRequestParams {
  reason: SupportRequestReason
  name?: string
  cpf?: string
  phone?: string
  email?: string
  description?: string
  screen?: string
}

export async function createPublicSupportRequest({
  screen,
  ...body
}: CreatePublicSupportRequestParams) {
  const { data } = await httpClient.post<SupportRequest>(
    '/support-requests/public',
    body,
    screen ? { headers: { 'X-Screen': screen } } : undefined,
  )

  return data
}
